/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Body_2Inputs */

const en_wb_sales_body_2 = /** @type {(inputs: Wb_Sales_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You mentioned that enquiries arrive by email, but follow-ups are tracked separately in a spreadsheet. That sounds like a useful place to start.`)
};

const lv_wb_sales_body_2 = /** @type {(inputs: Wb_Sales_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs minējāt, ka pieprasījumi pienāk e-pastā, bet atgādinājumi tiek uzskaitīti atsevišķi izklājlapā. Tas šķiet labs sākumpunkts.`)
};

/**
* | output |
* | --- |
* | "You mentioned that enquiries arrive by email, but follow-ups are tracked separately in a spreadsheet. That sounds like a useful place to start." |
*
* @param {Wb_Sales_Body_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_body_2 = /** @type {((inputs?: Wb_Sales_Body_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Body_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_body_2(inputs)
	return en_wb_sales_body_2(inputs)
});